import { useReducer, useEffect, useMemo } from "react";
import * as auth from "../auth";

/**
 * @returns null if not yet logged in. Object with token and parsedToken if
 * logged in.
 */
export const useLoginToken = () => {
  const [token, dispatch] = useReducer(auth.getToken, undefined, auth.getToken);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const memoToken = useMemo(() => token, [token?.token]);

  useEffect(() => {
    const unsubscribe = auth.onTokenUpdate(dispatch);

    // This function is called in a later tick. What if onAuthSuccess or another
    // of these events happen after useReducer initial state has been set. But
    // before listening starts to these events. Let's cover our asses.. We have
    // had issues where the page hangs on the initial sinch logo loader.
    dispatch();

    return unsubscribe;
  }, []);

  return memoToken;
};
